export default "__VITE_ASSET__SBrdxk68__"